import React from "react";
import ControlDragComponent from "./subcomponents/ControlDragComponent";
import { FormContainerList, FormControlList } from "../../utils/formBuilderUtils";

const LeftSidebar = (props) => {
  // Helper function to filter and render controls by category
  const renderCategoryItems = (category) => {
    return FormControlList.filter((control) => control.category === category).map(
      (control) => (
        <div className="col-6" key={control.controlName}>
          <ControlDragComponent
            item={control}
            handleItemAdded={props.handleItemAdded}
            formLayoutComponents={props.formLayoutComponents}
          />
        </div>
      )
    );
  };

  return (
    <div className="container">
      <h5>Containers</h5>
      {FormContainerList.map((container) => (
        <ControlDragComponent
          key={container.controlName}
          item={container}
          handleItemAdded={props.handleItemAdded}
          formLayoutComponents={props.formLayoutComponents}
        />
      ))}
      
      <div className="m-t-30"></div>

      <h5>Text Elements</h5>
      <div className="row">{renderCategoryItems("text-elements")}</div>

      <div className="m-t-30"></div>

      <h5>Date Elements</h5>
      <div className="row">{renderCategoryItems("date-elements")}</div>

      <div className="m-t-30"></div>

      <h5>Other Elements</h5>
      <div className="row">{renderCategoryItems("other-elements")}</div>

      <div className="m-t-30"></div>

      <h5>Media Elements</h5>
      <div className="row">{renderCategoryItems("media-elements")}</div>
    </div>
  );
};

export default LeftSidebar;
